<template>
  <div class="index-page" :class="{'state-projects': state==='PROJECTS'}">

    <burger-menu
      @openMenu="menuOpened='false'"
    />

    <Transition name="side-menu-transition">
      <side-menu
        v-if="menuOpened"
        @closeMenu="menuOpened=false"
      />
    </Transition>

    <Transition name="side-menu-mask">
      <div v-if="menuOpened" @click="menuOpened=false" class="side-menu-mask"></div>

    </Transition>

    <div class="logo-section">
      <!--..............entering logo animation..............-->
      <logo-animation ref="logoAnimation"/>
      <transition name="brand-transition">
        <div key="brand" class="brand-name">
          <loading-logo ref="loadingLogo" @resetState="resetState"/>
        </div>
      </transition>
    </div>

    <!--    <transition name="projects-transition">-->
    <!--      <project-list-->
    <!--        v-if="state==='PROJECTS'"-->
    <!--        @reset="resetState"-->
    <!--      />-->
    <!--    </transition>-->
    <!--..............entering logo animation..............-->

    <div class="hero-wrapper">
      <hero-section/>

      <trusted-by-section/>
    </div>


<!--    <product-intro-section/>-->

    <product-section1/>

    <product-section4/>

    <product-section3/>

    <product-section2/>

    <footer-section/>


  </div>


</template>

<script>
import LogoAnimation from "../components/LogoAnimation";
import MainNav from "../components/MainNav";
import Project from "../components/Project";
import ProjectList from "../components/ProjectList";
import LoadingLogo from "../components/LoadingLogo";
import SecondaryNav from "../components/SecondaryNav";
import BurgerMenu from "../components/icons/BurgerMenu";
import SideMenu from "../components/sideMenu/SideMenu";
import ProductSection1 from "../sections/ProductSection1";
import FooterSection from "../sections/FooterSection";
import ProductSection2 from "../sections/ProductSection2";
import ProductSection3 from "../sections/ProductSection3";
import ProductIntroSection from "../sections/ProductIntroSection";
import ProductSection4 from "../sections/ProductSection4";
import TrustedBySection from "../sections/TrustedBySection";
import HeroSection from "../sections/HeroSection";

export default {
  data: () => ({
    menuOpened: false,
  }),

  name: "IndexPage",
  components: {
    HeroSection,
    TrustedBySection,
    ProductSection4,
    ProductIntroSection,
    ProductSection3,
    ProductSection2,
    FooterSection,
    ProductSection1,
    SideMenu, BurgerMenu, SecondaryNav, LoadingLogo, ProjectList, Project, MainNav, LogoAnimation
  },


  methods: {
    onStateChanged() {
      this.$refs.loadingLogo.startAnimation();

      setTimeout(() => {
        this.$refs.logoAnimation.animateLogo();
        this.$refs.logoAnimation.pauseLogo(2000);
        this.state = 'PROJECTS';
      }, 300)

    },
    resetState() {
      this.state = 'INIT';
      this.$refs.logoAnimation.animateLogo();
      this.$refs.loadingLogo.revertLogo();
    }
  },

  mounted() {
    setTimeout(() => {
      this.$refs.logoAnimation.animateLogo()
    }, 300)
  }

}
</script>

<style lang="scss">
@import "LandingPage";
</style>
